import script from "./MOM.vue?vue&type=script&lang=js"
export * from "./MOM.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__